module.exports = {"title":"핀","selectGolfClubPlaceholder":"골프클럽을 선택하세요.","selectTypePlaceholder":"유형을 선택하세요.","realTimePinPosition":"실시간 핀 위치","periodPinPosition":"기간별 핀 위치","months":"{n}개월","flag":"깃","totalCount":"전체 {n}건","pin":"핀","date":"날짜","time":"시간","duration":"지속 시간","noData":"데이터가 없습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/gr302.json
// module id = AMee
// module chunks = 2